/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {NgModule} from '@angular/core';
import {MyRequiredValidatorDirective} from './required-validator.directive';

@NgModule({
    declarations: [MyRequiredValidatorDirective],
    exports: [MyRequiredValidatorDirective],
})
export class MyRequiredValidatorModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/required/required-validator.module.ts